import { Box3, Intersection, Raycaster, Scene, Vector3 } from 'three';

import { SkyviewCamera } from '../../cameras/types';
import { pickNearCursor } from '../../utilities/pick-near-cursor';

export abstract class Tiled3dModel extends Scene {
  abstract getType(): '3d-tiles-renderer' | 'skymap-tiles-renderer' | 'gltf-tiles-renderer';

  abstract loadLodChunks(camera: SkyviewCamera): Promise<void>;
  abstract cullLodChunks(camera: SkyviewCamera): void;

  abstract activate(): Promise<void>;

  abstract isLoading(): boolean;

  abstract pick(ray: Raycaster): Intersection[];

  /** Every hit of a ray from the camera, at the positions they are at. */
  abstract intersect(rayCaster: Raycaster): Intersection[];

  /** Picks the front-most hit near the cursor, see pickNearCursor. */
  pickNearCursor(camera: SkyviewCamera, rayCaster: Raycaster): Intersection | undefined {
    return pickNearCursor(camera, rayCaster, this.intersect(rayCaster));
  }

  abstract getBoundingBox(): Box3;

  abstract getOrigo(): Vector3;

  abstract clearCustom(): void;
}
